import React, { useRef, useState } from "react";
import PhotoPicker from "../PhotoPicker";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import PhotoCameraRoundedIcon from "@mui/icons-material/PhotoCameraRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import PlayerAvatar from "../ui/PlayerAvatar";
import api from "../../api";
import { resizeImage } from "../../utils/image";
import { atualizarFotoCache } from "../../utils/fotos";
import tokens from "../../theme/tokens";

/**
 * Upload da foto de perfil para o Cloudflare R2.
 * Sem `userId` altera a foto do usuário logado; com `userId` (Admin/Diretor) altera a de outro usuário.
 */
export default function AvatarInput({ src, name, userId, size = 120, onChange, onError }) {
  const inputRef = useRef();
  const [loading, setLoading] = useState(false);
  const endpoint = userId ? `user/${userId}/photo` : "user/photo";

  async function handleFile(selected) {
    if (!selected) return;

    setLoading(true);
    try {
      const file = await resizeImage(selected, { maxSize: 800 });
      const response = await api.upload(endpoint, file);
      atualizarFotoCache(response.data.data._id, response.data.data.foto);
      onChange && onChange(response.data.data);
    } catch (error) {
      onError && onError(error.response?.data?.error || "Não foi possível enviar a foto.");
    } finally {
      setLoading(false);
    }
  }

  async function handleRemove() {
    setLoading(true);
    try {
      const response = await api.remove(endpoint);
      atualizarFotoCache(response.data.data._id, null);
      onChange && onChange(response.data.data);
    } catch (error) {
      onError && onError(error.response?.data?.error || "Não foi possível remover a foto.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Stack alignItems="center" spacing={1.5}>
      <Box sx={{ position: "relative" }}>
        <PlayerAvatar src={src} name={name} size={size} ring />
        {loading && (
          <Box sx={{ position: "absolute", inset: 0, borderRadius: "50%", bgcolor: "rgba(0,0,0,0.45)", display: "grid", placeItems: "center" }}>
            <CircularProgress size={32} sx={{ color: "#fff" }} />
          </Box>
        )}
        <Tooltip title="Alterar foto">
          <IconButton
            onClick={() => inputRef.current.click()}
            disabled={loading}
            sx={{ position: "absolute", right: -4, bottom: -4, bgcolor: tokens.color.brand, color: "#fff", border: "3px solid #fff", "&:hover": { bgcolor: tokens.color.brandDark } }}
            size="small"
          >
            <PhotoCameraRoundedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={(e) => { const f = e.target.files[0]; e.target.value = ""; handleFile(f); }} style={{ display: "none" }} />
      <PhotoPicker onPick={handleFile} disabled={loading} size="small" />
      <Stack direction="row" spacing={1}>
        {src && (
          <Button size="small" color="inherit" startIcon={<DeleteOutlineRoundedIcon />} onClick={handleRemove} disabled={loading}>
            Remover
          </Button>
        )}
      </Stack>
      <Typography variant="caption" color="text.secondary">JPG, PNG ou WEBP · a foto aparece nos cards do torneio</Typography>
    </Stack>
  );
}
